import React from 'react';
import './About.css';
import profileImage from '../assets/images/profile2.jpeg';

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        
        {/* BIOGRAPHY SECTION */}
        <div className="biography-section">
          <h1>Biography</h1>
          <div className="bio-text">
            <p>
              Praised for her crystalline voice and expressive interpretation, 
              Soohyun Jo has established herself as a rising classical soprano 
              with a growing international presence. She has performed in various 
              concert halls including the Seoul Arts Center and collaborated with 
              elite orchestras worldwide.
            </p>
            <p>
            In recent years, she appeared as a soloist with the City Philharmonic Orchestra 
            at Youngsan Art Hall and participated in the renowned Seoul CHORAL Festival 
            at the Seoul Arts Center. She also performed as a soloist at the Civica Scuola delle Arti Festival, 
            further expanding her repertoire with particular acclaim for her interpretations of Mozart.
            </p>
            <p>
            She is currently pursuing a Master’s degree in Vocal Performance 
            at the Manhattan School of Music in New York, further refining her artistry through studies and performances.
            </p>
          </div>
          <img src={profileImage} alt="Soohyun Jo" className="profile-image" />
        </div>

        {/* UPCOMING ROLES */}
        <div className="achievements-section">
          <h2>Upcoming Roles</h2>
          <ul className="awards-list">
            <li>
              <strong>Contessa</strong> in <em>Le nozze di Figaro</em>, Keystone Opera (2025)
            </li>
          </ul>
        </div>

        {/* CONCERT AND CHORAL */}
        <div className="achievements-section">
          <h2>Concert and Choral</h2>
          <ul className="awards-list">
            <li>
              Soloist, Elite Symphony Orchestra (Gwachen Civic Center Grand Theatre, 2024)
            </li>
            <li>
              Ensemble, Seoul CHORAL Festival (Seoul Arts Center, 2023)
            </li>
            <li>
              Soloist, Hana Art Production with Seocho-gu 
              (Mozart Hall Seocho, 2023)
            </li>
            <li>
              Soloist, La Grande Musica Sotto Le Stelle 
              (Festival Federico Cesi, 2022)
            </li>
            <li>
              Soloist, CityPhilharmoni Orchestra 
              (Youngsan Art Hall, 2021)
            </li>
          </ul>
        </div>

        {/* AWARDS */}
        <div className="achievements-section">
          <h2>Awards</h2>
          <ul className="awards-list">
            <li>
              Young Virtuoso Concours — Top scored in college department, South Korea (2023)
            </li>
            <li>
              The 8th Ethan Classic Music Concours — Top scored in college department, South Korea (2023)
            </li>
            <li>
              CityPhilharmoni Orchestra Award — 1<sup>st</sup> place in rising star competition, South Korea (2021)
            </li>
          </ul>
        </div>

        {/* EDUCATION */}
        <div className="education-section">
          <h2>Education</h2>
          <ul className="education-list">
            <li>
              <span className="degree">Master of Music, Classical Voice</span>
              <span className="school">Manhattan School of Music</span>
              <span className="year">2026</span>
            </li>
            <li>
              <span className="degree">Bachelor of Music, Classical Voice</span>
              <span className="school">Chung-Ang University</span>
              <span className="year">2024</span>
            </li>
            <li>
              <span className="degree">Diploma, perfect score 10/10, Classical Voice</span>
              <span className="school">Civica Scuola Delle Arti</span>
              <span className="year">2022</span>
            </li>
          </ul>
        </div>

        {/* TEACHERS & COACHES */}
        <div className="education-section">
          <h2>Teachers & Coaches</h2>
          <ul className="awards-list">
            <li><strong>Teachers:</strong> Christophen Nomura, Junghyun Kim, Mariangela Di Giamberardino, Ambra Vespasiani</li>
            <li><strong>Coaches:</strong> Nobuko Amemiya, Riko Higuma</li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default About;
